const loginForm = () => {
  const form = document.querySelector('.login-form form');
  const response = document.querySelector('.login-form .form-response');
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    response.innerHTML = 'Login invalid. Please enter a valid username and password.';
    response.classList.add('error');
  });
};

export default loginForm;
